import Accordion from 'accordion-js';

VIV.behaviours.contactCollapse = (function () {
    const attach = function (context) {
        const baseClass = 'accordion';
        context.querySelectorAll(`.${baseClass}`).forEach(element => {
            new Accordion(element, {
                showMultiple: false,
                elementClass: `${baseClass}__item`,
                triggerClass: `${baseClass}__itemTrigger`,
                panelClass: `${baseClass}__itemPanel`,
                activeClass: `${baseClass}__item--isActive`,
            });
        });
    };

    return {
        attach: attach
    }
})();
